import { Box } from "@mui/material";
import PageHeader from "components/AppBar/PageHeader";
import { BasePathProvider, useSession } from "components/Providers";
import { Route, Routes } from "react-router-dom";
// import { getAdminStandards } from "store/lookup";
// import { useDispatch, useSelector } from "react-redux";
// import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SubstituteIndex from "./SubstitutePortal";
import NoAccess from "components/NoAccess";

export default function SubstitutePortal() {
    const basePath = '/substitute-portal'
    // const adminStandards = useSelector(state => state.lookup.adminStandards)
    // const dispatch = useDispatch()
    const { t } = useTranslation();

    // useEffect(() => {
    //   adminStandards || dispatch(getAdminStandards())
    // }, [Boolean(adminStandards), dispatch]);  
    const { permissions } = useSession();

    return (
        <BasePathProvider value={`${basePath}/`}>
            <Box sx={{ mb: 2 }}>
                <PageHeader title={t('Substitute Portal')} />
            </Box>
            <Box sx={{ width: '100%', minHeight: '500px' }}>
                {!permissions['substitute.portal'] ? <NoAccess /> : (
                    <Routes>
                        <Route path="/">
                            <Route path="" element={<SubstituteIndex />} />
                            <Route path="/*" element={<SubstituteIndex />} />
                        </Route>
                    </Routes>
                )}
            </Box>

        </BasePathProvider>
    )
}
